module.exports = __webpack_public_path__ + "static/img/recondo-1.aedb14e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/recondo-1.jpg
// module id = MlhD
// module chunks = 1